var module = angular.module('octopusApp.projects');

module.directive('actionTemplateEditor', function() {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'areas/projects/views/action_template_editor.html',
    scope: {
      actionTemplate: '=',
      action: '=',
      process: '=',
      project: '='
    },
    controller: function($scope, sensitiveValue, actionUpdater){

      $scope.createResetValues = function() {
        $scope.resetValues = {};
        if ($scope.action == null) {
            return;
        }

        _.each($scope.actionTemplate.Parameters, function(parameter){

          if (parameter.DisplaySettings['Octopus.ControlType'] === 'Sensitive') {
            $scope.resetValues[parameter.Name] = sensitiveValue.getResetValue($scope.action.Properties[parameter.Name]);
            return;
          }

          if (parameter.Name in $scope.action.Properties) {
            $scope.resetValues[parameter.Name] = $scope.action.Properties[parameter.Name];
            return;
          }
        });
      };

      if ($scope.process) {
        $scope.allSteps = _.flatten($scope.process.Steps.map(function(a) { return a.Actions.map(function(action) { return action.Name; }); }));
      }
      
      $scope.mergeLatest = function() {

        actionUpdater.update($scope.action, $scope.actionTemplate);
        $scope.actionUpdated = true;
        $scope.$emit("actionTemplateEditor:dirty");
        $scope.createResetValues();
      };

      $scope.createResetValues();
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/directives/action_template_editor.js
// module id = 535
// module chunks = 1